"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import Telegram from "../Svg/Telegram";
import InstagramFooter from "../Svg/InstagramFooter";
import useFooter from "@/hooks/useFooter";
import Skeleton from "react-loading-skeleton";
import DOMPurify from "dompurify";

function MainFooter() {
  const { data: footerData, isLoading } = useFooter();

  const [sanitizedHtmlContent, setSanitizedHtmlContent] = useState<string>("");

  useEffect(() => {
    if (!footerData) return;

    const sanitized = DOMPurify.sanitize(footerData?.enamadImg || "", {
      ADD_ATTR: [
        "href",
        "src",
        "alt",
        "style",
        "target",
        "referrerpolicy",
        "code",
      ],
    });

    setSanitizedHtmlContent(sanitized);
  }, [footerData]);

  return (
    <div className="flex justify-between xxl:container xxl:mx-auto  items-center px-6 lg:px-16 py-10 mt-5 lg:mt-32 lg:flex-row flex-col gap-4 sm:gap-0 border-t border-ws-gray-200">
      <div className="flex flex-col gap-3 items-center  sm:items-start">
        {isLoading ? (
          <Skeleton width={112} height={112} borderRadius={10} />
        ) : (
          <Link href="/">
            <Image
              priority
              fetchPriority="high"
              sizes="100vw"
              width={500}
              height={300}
              className="w-auto h-[50px] lg:h-[110px] mb-5 footer-big-logo"
              src={`${process.env.NEXT_PUBLIC_ADMIN_URL}/${footerData?.footerLogo}`}
              alt="footer-logo"
              unoptimized
            />
          </Link>
        )}

        {isLoading ? (
          <div className="social-media  w-full justify-center  gap-3 items-center  hidden lg:flex">
            <Skeleton width={30} height={30} borderRadius={10} />
            <Skeleton width={30} height={30} borderRadius={10} />
          </div>
        ) : (
          <div className="social-media  w-full justify-center  gap-3 items-center  hidden lg:flex">
            <Link href={footerData?.telegramLink ?? "/"}>
              <Telegram />
            </Link>

            <Link href={footerData?.instageramLink ?? "/"}>
              <InstagramFooter />
            </Link>
          </div>
        )}
      </div>

      {isLoading ? (
        <div className="flex flex-col gap-4 text-right text-sm lg:text-base items-center lg:items-start">
          <Skeleton width={200} height={30} borderRadius={10} />
          <Skeleton
            width={200}
            height={30}
            borderRadius={10}
            className="mt-4"
          />
          <Skeleton width={200} height={30} borderRadius={10} />
          <Skeleton width={200} height={30} borderRadius={10} />
        </div>
      ) : (
        <div className="flex flex-col gap-4 text-right text-sm lg:text-base items-center lg:items-start">
          <h3 className="text-ws-gray-700 mb-3">{footerData?.siteName}</h3>
          <Link href="/about">درباره ما</Link>
          <Link href="/contact">تماس با ما</Link>
          <Link href="/blogList"> بلاگ ها</Link>
        </div>
      )}
      {isLoading ? (
        <div className="flex flex-col gap-4   text-sm lg:text-base items-center  lg:items-start lg:mt-0 mt-3">
          <Skeleton width={200} height={30} borderRadius={10} />
          <Skeleton
            width={200}
            height={30}
            borderRadius={10}
            className="mt-4"
          />
          <Skeleton width={200} height={30} borderRadius={10} />
          <Skeleton width={200} height={30} borderRadius={10} />
        </div>
      ) : (
        <div className="flex flex-col gap-4   text-sm lg:text-base items-center  lg:items-start lg:mt-0 mt-3">
          <h3 className="text-ws-gray-700 mb-3 hidden lg:inline-block">
            راهنما و قوانین
          </h3>
          <Link href="/rules">قوانین و خدمات</Link>
          <Link href="/suggestion">انتقادات و پیشنهادات</Link>
          <Link href="/FAQ">پرسش‌های متداول</Link>
        </div>
      )}
      {isLoading ? (
        <div className="flex flex-col gap-4   text-sm lg:text-base items-center  lg:items-start lg:mt-0 mt-3">
          <Skeleton width={200} height={30} borderRadius={10} />
          <Skeleton
            width={200}
            height={30}
            borderRadius={10}
            className="mt-4"
          />
          <Skeleton width={200} height={30} borderRadius={10} />
          <Skeleton width={200} height={30} borderRadius={10} />
        </div>
      ) : (
        <div className=" flex-col gap-4 hidden lg:flex  text-sm lg:text-base items-center  lg:items-start lg:mt-0 mt-3">
          <h3 className="text-ws-gray-700 mb-3">راه‌های دسترسی</h3>
          <address className=" not-italic text-center">
            {footerData?.addresss}
          </address>
          <Link href={`tel:${footerData?.phone}`} className="cursor-pointer">
            {footerData?.phone}
          </Link>
          {footerData?.email ? (
            <Link
              href={`mailto:${footerData?.email}`}
              className="cursor-pointer"
            >{`${footerData?.email}`}</Link>
          ) : (
            <span>لطفا ایمیل خود را وارد کنید</span>
          )}
        </div>
      )}

      {isLoading ? (
        <div className="social-media  my-3  gap-5 items-center flex lg:hidden">
          <Skeleton width={30} height={30} borderRadius={10} />
          <Skeleton width={30} height={30} borderRadius={10} />
        </div>
      ) : (
        <div className="social-media  my-3  gap-5 items-center  flex lg:hidden">
          <Link href={footerData?.telegramLink ?? "/"}>
            <Telegram />
          </Link>

          <Link href={footerData?.instageramLink ?? "/"}>
            <InstagramFooter />
          </Link>
        </div>
      )}
      {isLoading ? (
        <div className="flex gap-10 items-center">
          <Skeleton width={112} height={112} borderRadius={10} />
          <Skeleton width={112} height={112} borderRadius={10} />
        </div>
      ) : (
        <div className="flex gap-10 items-center">
          <div className="w-28 h-28 flex items-center justify-center namad-logo">
            <div
              dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}
            ></div>
          </div>
          <div className="w-28 h-28 flex items-center justify-center namad-logo"></div>
        </div>
      )}
    </div>
  );
}

export default MainFooter;
